import { render } from "./NeginMadarParsaDez.vue?vue&type=template&id=b68d3662"
import script from "./NeginMadarParsaDez.vue?vue&type=script&lang=js"
export * from "./NeginMadarParsaDez.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/holdingalmas-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__